import { Venue } from "@ticketingplatform/api/dist/venue/__generated__/Venue";
import { message } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { useVenueContext } from "contexts/VenueContext";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";

import { UseEmbedForm } from "./types";
import { makeWidgetEmbedCode } from "./utils";

export const useEmbedForm: UseEmbedForm = () => {
  const intl = useIntl();
  const { venue: contextVenue } = useVenueContext();
  const [selectedVenues, setSelectedVenues] = useState<Venue[]>([]);
  const [checkedVenues, setCheckedVenues] = useState<number[]>([]);
  const embedScriptCode = useMemo(
    () => makeWidgetEmbedCode(checkedVenues),
    [checkedVenues]
  );

  useEffect(() => {
    setSelectedVenues(contextVenue ? [contextVenue] : []);
    setCheckedVenues(contextVenue ? [contextVenue.id] : []);
  }, [contextVenue]);

  return {
    venueCheckboxes: useMemo(
      () =>
        selectedVenues.map(({ id, name }) => {
          const checked = checkedVenues.includes(id);

          return {
            key: id,
            checked,
            children: name,
            onChange: ({ target }: CheckboxChangeEvent) => {
              if (target.checked) {
                if (checked) {
                  return;
                }

                setCheckedVenues((prevCheckedVenues) => [
                  ...prevCheckedVenues,
                  id,
                ]);
              } else {
                setCheckedVenues((prevCheckedVenues) =>
                  prevCheckedVenues.filter(
                    (checkedVenue) => checkedVenue !== id
                  )
                );
              }
            },
          };
        }),
      [checkedVenues, selectedVenues]
    ),
    embedScript: {
      value: embedScriptCode,
      readOnly: true,
      onClick: useCallback(() => {
        window.navigator.clipboard.writeText(embedScriptCode);

        message.success(
          intl.formatMessage({
            defaultMessage: "Copied to clipboard!",
          })
        );
      }, [embedScriptCode, intl]),
    },
    venueSelect: {
      onChange: (venue) => {
        if (!venue || selectedVenues.some(({ id }) => id === venue.id)) {
          return;
        }

        setSelectedVenues((prev) => [...prev, venue]);
        setCheckedVenues((prevCheckedVenues) => [
          ...prevCheckedVenues,
          venue.id,
        ]);
      },
    },
  };
};
